// Each tab's tiles, built from its summary strip. Declared apart so the views can memoise them.

export const buildContractTiles = (t, strip) => [
  { label: t('INVENTORY_SUMMARY_CONTRACTED'), value: strip?.contracted },
  { label: t('INVENTORY_SUMMARY_SHIPPED'), value: strip?.shipped },
  { label: t('INVENTORY_SUMMARY_OUTSTANDING'), value: strip?.outstanding },
];

export const buildShipmentTiles = (t, strip) => [
  { label: t('INVENTORY_SUMMARY_SHIPMENT'), value: strip?.shipment },
  { label: t('INVENTORY_SUMMARY_RECEIVED_DECLARATION'), value: strip?.received },
  { label: t('INVENTORY_SUMMARY_PENDING'), value: strip?.pending },
  { label: t('INVENTORY_SUMMARY_AVAILABLE'), value: strip?.available },
];

export const buildDeclarationTiles = (t, strip) => [
  { label: t('INVENTORY_SUMMARY_RECEIVED_DECLARATION'), value: strip?.received },
  { label: t('INVENTORY_SUMMARY_ADJUSTED_CERTIFIED'), value: strip?.adjusted },
  { label: t('INVENTORY_SUMMARY_AVAILABLE'), value: strip?.available },
];

export const buildOrderTiles = (t, strip) => [
  { label: t('INVENTORY_SUMMARY_CONTRACTED'), value: strip?.contracted },
  { label: t('INVENTORY_SUMMARY_SHIPPED'), value: strip?.shipped },
  { label: t('INVENTORY_SUMMARY_ALLOCATED'), value: strip?.allocated },
  { label: t('INVENTORY_SUMMARY_REMAINING_TO_ALLOCATE'), value: strip?.remainingToAllocate },
];

export const buildOutgoingShipmentTiles = (t, strip) => [
  { label: t('INVENTORY_SUMMARY_SHIPMENT'), value: strip?.shipment },
  { label: t('INVENTORY_SUMMARY_ALLOCATED'), value: strip?.allocated },
  { label: t('INVENTORY_SUMMARY_REMAINING_TO_ALLOCATE'), value: strip?.remainingToAllocate },
];

export const buildAllocationTiles = (t, strip) => [
  { label: t('INVENTORY_SUMMARY_ALLOCATED'), value: strip?.allocated },
];
